import React from 'react';
import styled from "styled-components"
import { ListItem } from "./ListItem";

const StyledLi = styled.li`list-style: none;`;
const StyledUl = styled.ul`padding: 0`;
const placeholder = document.createElement("li");
placeholder.className = "placeholder";

let dragged = null;
let over = null;

export const List = props => {
	const dragStart = ({currentTarget, dataTransfer}) => {
		dragged = currentTarget;
		dataTransfer.effectAllowed = 'move';
		dataTransfer.setData('text/html', dragged);
	};
	
	const dragEnd = () => {
		dragged.style.display = 'block';
		dragged.parentNode.removeChild(placeholder);

		let [from, to] = [+dragged.dataset.id, +over.dataset.id];
		if (from < to) {
			to = to - 1;
		}
		let data = props.urls;
		data.splice(to, 0, data.splice(from, 1)[0]);

		props.update(data);
	};
	
	const dragOver = (e) => {
		e.preventDefault();
		if (!e.target.closest('li')) {
			return false;
		}
		const target = e.target.closest('li');
		dragged.style.display = "none";
		if (target.className === 'placeholder') {
			return;
		}
		over = target;
		target.parentNode.insertBefore(placeholder, target);
	};

	const listItems = props.urls.map((item, i) =>
		<StyledLi className={item} data-id={i} key={i} draggable='true' onDragEnd={dragEnd} onDragStart={dragStart}>
			<ListItem i={i} item={item} {...props} />
		</StyledLi>
	);

	return <StyledUl onDragOver={dragOver}>{listItems}</StyledUl>;
};